import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 3855,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 1009,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 310,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/x7i2zxk9_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bluoaslc_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/onuzlf6c_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kgs12m0l_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mmrt5lwv_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/oh0rhuse_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/eesoqn5l_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4i3ow2k0_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bqs4yxsw_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 72,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f04wbk9f_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Mentors"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 16,
										width: 60,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/p95n6tb9_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/n7z4at1w_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/a4cpclq0_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cwk1jzrc_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/i5b4iu2t_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ma73qs0m_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mhcscwd7_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/r6b0usyk_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5wfrqoae_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mvjkvow7_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Mentors"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 38,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 42,
							}} >
							{"Explore all mentors"}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Mentors"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #00AEEF`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6qfjfpb6_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#0BBB0D",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Available"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 105,
											}} >
											{"Jenny Wilson"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sx73xf18_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fzvzp66a_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5gkp0lhz_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3xlnwmx0_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w2fmdrpp_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#EEBD10",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Limited Availability"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 108,
											}} >
											{"Guy Hawkins"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pjzibij3_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6zh8av42_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/r0chhcov_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kqhdzzod_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									marginBottom: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1ih4dcwh_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FF3737",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Unavailable"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 126,
											}} >
											{"Robert Fox"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9256ix1b_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/on6jrdag_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8qk5wmsd_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mkumrnom_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									padding: 16,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lmvrbsih_expires_30_days.png"} 
									style={{
										width: 90,
										height: 116,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#0BBB0D",
											borderRadius: 2,
											paddingTop: 1,
											paddingBottom: 1,
											paddingLeft: 6,
											paddingRight: 6,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 9,
												fontWeight: "bold",
											}} >
											{"Available"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												marginRight: 97,
											}} >
											{"Bessie Cooper"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/chm0ghsp_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
									</div>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 6,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zov3ayhy_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/chzwey37_expires_30_days.png"} 
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"SEO Expert, Startup Advisor"}
											</span>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iija9lfv_expires_30_days.png"} 
												style={{
													width: 10,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"2 Years of experience"}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1146,
								background: "#E6E6E6",
								marginRight: 3,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 4,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
									marginLeft: 20,
								}} >
								{"Mentor Profile"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
									marginLeft: 20,
									marginRight: 20,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 29,
									marginLeft: 20,
									gap: 20,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										position: "relative",
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/camazrsn_expires_30_days.png"} 
										style={{
											width: 80,
											height: 80,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											position: "absolute",
											bottom: -6,
											left: 12,
											width: 56,
											display: "flex",
											flexDirection: "column",
											background: "#0BBB0D",
											borderRadius: 4,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 10,
												fontWeight: "bold",
												textAlign: "center",
												marginTop: 2,
												marginBottom: 2,
												marginLeft: 6,
												marginRight: 6,
											}} >
											{"Available"}
										</span>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											marginBottom: 8,
										}} >
										{"Jenny Wilson"}
									</span>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Senior Teacher at Harvard University"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											paddingRight: 1,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/icxz9qeg_expires_30_days.png"} 
											style={{
												width: 12,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"New York City, USA"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 12,
									marginLeft: 20,
									marginRight: 20,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#1074BC",
									borderRadius: 8,
									paddingTop: 12,
									marginBottom: 24,
									marginLeft: 20,
									marginRight: 20,
									gap: 10,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 5,
										gap: 22,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 14,
											fontWeight: "bold",
											marginTop: 1,
											marginBottom: 1,
										}} >
										{"Application"}
									</span>
									<span 
										style={{
											color: "#E7F1F8",
											fontSize: 14,
											marginTop: 1,
											marginBottom: 1,
										}} >
										{"Expertise"}
									</span>
									<span 
										style={{
											color: "#E7F1F8",
											fontSize: 14,
										}} >
										{"Experience"}
									</span>
									<span 
										style={{
											color: "#E7F1F8",
											fontSize: 14,
											marginTop: 1,
											marginBottom: 1,
										}} >
										{"Availability"}
									</span>
								</div>
								<div 
									style={{
										width: 78,
										height: 3,
										background: "#FFFFFF",
										borderTopLeftRadius: 8,
										borderTopRightRadius: 9,
										marginLeft: 5,
										boxShadow: "0px 1px 2px #00000012",
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 24,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
										marginRight: 141,
									}} >
									{"Activity Overview:"}
								</span>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#EEBD10",
										borderRadius: 4,
										border: "none",
										paddingTop: 4,
										paddingBottom: 4,
										paddingLeft: 8,
										paddingRight: 8,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Pending"}
									</span>
								</button>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 24,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0t1ca1ha_expires_30_days.png"} 
									style={{
										width: 9,
										height: 9,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
									}} >
									{"Application acceptance pending"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 2,
									marginBottom: 24,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xmzt2z7q_expires_30_days.png"} 
									style={{
										width: 9,
										height: 9,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
									}} >
									{"Application viewed"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 20,
									marginRight: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/z4ck75yq_expires_30_days.png"} 
									style={{
										width: 9,
										height: 9,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
									}} >
									{"Application submitted - Sent on 7 April 2025"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
										marginBottom: 24,
										marginLeft: 20,
									}} >
									{"Your Application:"}
								</span>
								<button 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 20,
										paddingBottom: 20,
										marginBottom: 24,
										marginLeft: 20,
										marginRight: 20,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 10,
											marginLeft: 20,
										}} >
										{"Goal:"}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 24,
											marginLeft: 20,
										}} >
										{"Learn how to start finance business startup"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 10,
											marginLeft: 20,
										}} >
										{"Description:"}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 24,
											marginLeft: 20,
											width: 284,
										}} >
										{"Discover the essential steps to launching a successful finance startup."}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 10,
											marginLeft: 20,
										}} >
										{"Areas of Interest:"}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 24,
											marginLeft: 20,
										}} >
										{"Structuring my finance startup for success."}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 10,
											marginLeft: 20,
										}} >
										{"Preferred Communication Frequency:"}
									</span>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
											marginLeft: 20,
										}} >
										{"Monthly mentorship"}
									</span>
								</button>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 20,
										marginRight: 20,
										gap: 16,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #979797`,
											paddingTop: 16,
											paddingBottom: 16,
											paddingLeft: 51,
											paddingRight: 53,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8215w0cq_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Cacnel"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
											borderRadius: 8,
											border: `1px solid #00000000`,
											paddingTop: 16,
											paddingBottom: 16,
											paddingLeft: 44,
											paddingRight: 46,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5vbf91o6_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Message"}
										</span>
									</div>
								</div>
								<div 
									style={{
										width: 144,
										height: 5,
										background: "#000000",
										borderRadius: 100,
										marginTop: 21,
										marginBottom: 8,
										marginLeft: 129,
										marginRight: 129,
									}}>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1146,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 15,
									gap: 46,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Send Connection Request"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kz90olgf_expires_30_days.png"} 
									style={{
										width: 10,
										height: 10,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 277,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
										marginBottom: 20,
									}} >
									{"Learning Goals:"}
								</span>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 12,
										fontWeight: "bold",
										marginBottom: 12,
									}} >
									{"Goal"}
								</span>
								<input
									placeholder={"Select goal"}
									value={input3}
									onChange={(event)=>onChangeInput3(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginBottom: 20,
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 20,
										paddingRight: 20,
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 12,
										fontWeight: "bold",
										marginBottom: 12,
									}} >
									{"Description (optional)"}
								</span>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 67,
										paddingLeft: 20,
										paddingRight: 136,
										marginBottom: 24,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
										}} >
										{"Enter description..."}
									</span>
								</div>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 20,
									}} >
									{"Areas of Interest:"}
								</span>
								<div 
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 50,
										paddingLeft: 20,
										paddingRight: 20,
										marginBottom: 24,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											width: 230,
										}} >
										{"How to secure seed funding for my startup?"}
									</span>
								</div>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginBottom: 20,
										width: 196,
									}} >
									{"Preferred Communication Frequency:"}
								</span>
								<button 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 15,
										paddingBottom: 15,
										paddingLeft: 20,
										paddingRight: 20,
										marginBottom: 24,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginTop: 1,
											marginBottom: 1,
											marginRight: 118,
										}} >
										{"Select frequency"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/nb39unbh_expires_30_days.png"} 
										style={{
											width: 17,
											height: 17,
											objectFit: "fill",
										}}
									/>
								</button>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 8,
										border: `1px solid #00000000`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 40,
										paddingRight: 41,
										gap: 6,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gda3bi01_expires_30_days.png"} 
										style={{
											width: 17,
											height: 17,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Send Connection Request"}
									</span>
								</div>
							</div>
						</div>
					</div>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
						}}>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0hn2rvri_expires_30_days.png"} 
							style={{
								width: 7,
								height: 17,
								objectFit: "fill",
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}